module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Bold.560db5b1.woff2";